import { render, staticRenderFns } from "./ResetPassUser.vue?vue&type=template&id=cae73e74&scoped=true&"
import script from "./ResetPassUser.vue?vue&type=script&lang=js&"
export * from "./ResetPassUser.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassUser.vue?vue&type=style&index=0&id=cae73e74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae73e74",
  null
  
)

export default component.exports